require('./Breadcrumb.scss');

const React = require('react'),
    Router = require('react-router'),
    {Link} = Router,
    {map} = require('lodash/collection');


const BreadCrumbItem = React.createClass({displayName: "BreadCrumbItem",

    propTypes: {
        link: React.PropTypes.string,
        displayName: React.PropTypes.string
    },

    render() {
        const {link, displayName} = this.props;
        return (
            React.createElement("li", {className: "bp-breadcrumb__list-item"}, 
                link ? React.createElement(Link, {to: link}, displayName) : React.createElement("a", {hred: "#"}, displayName)
            )
        );
    }
});


const BreadCrumb = React.createClass({displayName: "BreadCrumb",

    propTypes: {
        items: React.PropTypes.array
    },

    render() {
        const itemsEl = map(this.props.items,
            item => React.createElement(BreadCrumbItem, {link: item.link, 
                                    displayName: item.displayName})
        );
        return (
            React.createElement("div", {className: "bp-breadcrumb"}, 
                React.createElement("ul", {className: "bp-breadcrumb__list"}, 
                    itemsEl
                )
            )
        );
    }
});

module.exports = BreadCrumb;



/** WEBPACK FOOTER **
 ** ./src/components/Commons/Breadcrumb/Breadcrumb.js
 **/